/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */

/**
 * Item session status definition based on QTI item lifecycle
 * https://www.imsglobal.org/question/qtiv2p1/imsqti_infov2p1.html#section10055s
 */
export default Object.freeze({
    initial: 'initial',
    interacting: 'interacting',
    suspended: 'suspended',
    closed: 'closed',
    modalFeedback: 'modalFeedback',
    review: 'review',
    solution: 'solution'
});
